export const OnlineExamActionTypes = {

  //get plan
  FETCH_ONLINEEXAM_START: "FETCH_ONLINEEXAM_START",
  FETCH_ONLINEEXAM_SUCCESS: "FETCH_ONLINEEXAM_SUCCESS",
  FETCH_ONLINEEXAM_FAILURE: "FETCH_ONLINEEXAM_FAILURE",
  RESET_ONLINEEXAM_STATE: "RESET_ONLINEEXAM_STATE",
  //get exam detail by ID
  FETCH_ONLINEEXAM_DETAIL_START: "FETCH_ONLINEEXAM_DETAIL_START",
  FETCH_ONLINEEXAM_DETAIL_SUCCESS: "FETCH_ONLINEEXAM_DETAIL_SUCCESS",
  FETCH_ONLINEEXAM_DETAIL_FAILURE: "FETCH_ONLINEEXAM_DETAIL_FAILURE",
  SET_EXAM_COUNTER: "SET_EXAM_COUNTER",
  SET_ONLINE_EXAM: "SET_ONLINE_EXAM",
  SET_CURRENT_QUESTION_INDEX: "SET_CURRENT_QUESTION_INDEX",
  //get exam result by ID
  FETCH_ONLINEEXAM_RESULT_START: "FETCH_ONLINEEXAM_RESULT_START",
  FETCH_ONLINEEXAM_RESULT_SUCCESS: "FETCH_ONLINEEXAM_RESULT_SUCCESS",
  FETCH_ONLINEEXAM_RESULT_WARNING: "FETCH_ONLINEEXAM_RESULT_WARNING",
  FETCH_ONLINEEXAM_RESULT_FAILURE: "FETCH_ONLINEEXAM_RESULT_FAILURE",
  //get exam result detail by ID
  FETCH_ONLINEEXAM_RESULT_DETAIL_START: "FETCH_ONLINEEXAM_RESULT_DETAIL_START",
  FETCH_ONLINEEXAM_RESULT_DETAIL_SUCCESS: "FETCH_ONLINEEXAM_RESULT_DETAIL_SUCCESS",
  FETCH_ONLINEEXAM_RESULT_DETAIL_FAILURE: "FETCH_ONLINEEXAM_RESULT_DETAIL_FAILURE",
  //get exam answer by ID
  FETCH_ONLINEEXAM_ANSWER_START: "FETCH_ONLINEEXAM_ANSWER_START",
  FETCH_ONLINEEXAM_ANSWER_SUCCESS: "FETCH_ONLINEEXAM_ANSWER_SUCCESS",
  FETCH_ONLINEEXAM_ANSWER_FAILURE: "FETCH_ONLINEEXAM_ANSWER_FAILURE",
  //post exam 
  FETCH_POST_EXAM_START: "FETCH_POST_EXAM_START",
  FETCH_POST_EXAM_SUCCESS: "FETCH_POST_EXAM_SUCCESS",
  FETCH_POST_EXAM_FAILURE: "FETCH_POST_EXAM_FAILURE",
  //get Results
  FETCH_RESULTS_START: "FETCH_RESULTS_START",
  FETCH_RESULTS_SUCCESS: "FETCH_RESULTS_SUCCESS",
  FETCH_RESULTS_FAILURE: "FETCH_RESULTS_FAILURE",
  RESET_RESULTS_LOADMORE: "RESET_RESULTS_LOADMORE",
  RESET_RESULTS_STATE: "RESET_RESULTS_STATE",
  //Options
  SET_SHOW_NEXT_QUESTION: "SET_SHOW_NEXT_QUESTION",
  //Answer
  SET_ANSWER: "SET_ANSWER",

  //Reset Error
  RESET_ERROR: "RESET_ERROR",
  //Current Page
  SET_CURRENT_PAGE: "SET_CURRENT_PAGE",
  //Exam Type
  SET_EXAM_MODE: "SET_EXAM_MODE",

  SET_UPLOADING_FILE: "SET_UPLOADING_FILE",

  //reset Plan Offset
  RESET_PLAN_OFFSET: "RESET_PLAN_OFFSET",

  //reset Result Offset
  RESET_RESULT_OFFSET: "RESET_RESULT_OFFSET",


};
